// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/chunks/" + chunkId + "." + {"183": "5155283aec5553b1","462": "3605d8e09cb71b40",}[chunkId] + ".js"
}